(function() {
  'use strict';

  /* ── Variant data from Liquid (set in hero section) ── */
  var variants = window.somaAshwaVariants || {};
  /* Read the initial variant from the rendered DOM so JS state matches what
     Liquid marked as active. Hardcoding 'v1' here caused ATC to add the 30-day
     variant while v2 (90-day) was visually selected. */
  var initialActiveCard = document.querySelector('.vc.is-active');
  var current = (initialActiveCard && variants[initialActiveCard.dataset.variant])
    ? initialActiveCard.dataset.variant
    : (variants.vsub ? 'vsub' : (variants.v2 ? 'v2' : 'v1'));

  /* ── Reduced motion (checked once, not reactive — OK for this context) ── */
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Price morph helper — 2-phase crossfade for text swaps on price elements.
       Old text slides up + fades out (150ms), new text slides in from below + fades in (200ms).
       Skipped entirely under prefers-reduced-motion. ── */
  function morphPrice(el, newText) {
    if (!el || el.textContent === newText) return;
    if (prefersReducedMotion) { el.textContent = newText; return; }
    el.style.display = 'inline-block';
    el.style.transition = 'opacity 150ms cubic-bezier(0.25,1,0.5,1), transform 150ms cubic-bezier(0.25,1,0.5,1)';
    el.style.opacity = '0';
    el.style.transform = 'translateY(-6px)';
    setTimeout(function() {
      el.textContent = newText;
      el.style.transform = 'translateY(6px)';
      /* force reflow so the next transition actually runs */
      void el.offsetWidth;
      el.style.transition = 'opacity 200ms cubic-bezier(0.16,1,0.3,1), transform 200ms cubic-bezier(0.16,1,0.3,1)';
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    }, 150);
  }

  /* ── DOM refs ── */
  var atcPriceEl = document.getElementById('atc-price');
  var atcStrikeEl = document.getElementById('atc-strike');
  var stickyPriceEl = document.getElementById('sticky-price');
  var variantInput = document.getElementById('pdp-variant-id');
  var sellingPlanInput = document.getElementById('pdp-selling-plan');
  var quantityInput = document.getElementById('pdp-quantity');
  var heroAtcBtn = document.getElementById('hero-atc-btn');
  var stickyAtcBtn = document.getElementById('sticky-atc-btn');
  var productForm = document.getElementById('pdp-product-form');
  var stickyBar = document.getElementById('sticky-bar');
  var productSection = document.getElementById('product');

  /* ══════════════════════════════════════════
     VARIANT SWITCHING
  ══════════════════════════════════════════ */
  function setVariant(v) {
    var d = variants[v];
    if (!d) return;

    current = v;

    /* Update hidden form inputs */
    if (variantInput) variantInput.value = d.variantId || '';
    if (sellingPlanInput) sellingPlanInput.value = d.sellingPlanId || '';
    if (quantityInput) quantityInput.value = d.quantity || 1;

    /* Update price displays — morph instead of instant swap */
    morphPrice(atcPriceEl, d.atcPrice);
    morphPrice(stickyPriceEl, d.stickyPrice);

    /* Strike-through compare price on ATC button — hide if absent */
    if (atcStrikeEl) {
      if (d.atcStrike && d.atcStrike !== d.atcPrice) {
        morphPrice(atcStrikeEl, d.atcStrike);
        atcStrikeEl.style.display = '';
      } else {
        atcStrikeEl.style.display = 'none';
      }
    }

    /* Toggle active states on variant cards */
    document.querySelectorAll('.vc').forEach(function(c) {
      c.classList.toggle('is-active', c.dataset.variant === v);
    });

    /* Sync sticky bar plan dropdown options */
    document.querySelectorAll('.sticky-bar__plan-option').forEach(function(b) {
      b.classList.toggle('is-active', b.dataset.sv === v);
    });

    /* Update sticky bar plan button label */
    var activeOption = document.querySelector('.sticky-bar__plan-option[data-sv="' + v + '"]');
    if (activeOption) {
      var labelEl = document.getElementById('sticky-plan-label');
      var priceEl = document.getElementById('sticky-plan-price');
      if (labelEl) labelEl.textContent = activeOption.querySelector('.sticky-bar__option-name').textContent;
      if (priceEl) priceEl.textContent = activeOption.querySelector('.sticky-bar__option-detail').textContent;
    }
  }

  /* Variant card clicks */
  document.querySelectorAll('.vc').forEach(function(c) {
    c.addEventListener('click', function() {
      setVariant(this.dataset.variant);
    });
  });

  /* Sticky bar plan option clicks */
  document.querySelectorAll('.sticky-bar__plan-option').forEach(function(b) {
    b.addEventListener('click', function() {
      setVariant(this.dataset.sv);
      var selector = document.getElementById('sticky-plan-selector');
      if (selector) selector.classList.remove('is-open');
    });
  });

  /* Sticky bar plan dropdown toggle */
  var planBtn = document.getElementById('sticky-plan-btn');
  var planSelector = document.getElementById('sticky-plan-selector');
  if (planBtn && planSelector) {
    planBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      planSelector.classList.toggle('is-open');
    });
    document.addEventListener('click', function(e) {
      if (!planSelector.contains(e.target)) {
        planSelector.classList.remove('is-open');
      }
    });
  }

  /* ══════════════════════════════════════════
     ADD TO CART — AJAX (includes selling_plan for subscription variants)
  ══════════════════════════════════════════ */
  function addToCart(btn) {
    var d = variants[current];
    if (!d || !d.variantId) return;

    /* Detect button pattern:
       - New pattern (hero ATC): has .btn-atc__label child → state classes + pour-fill
       - Old pattern (sticky bar): innerHTML swap */
    var isNewPattern = btn.classList.contains('btn-atc') && btn.querySelector('.btn-atc__label');
    var originalHTML;

    btn.disabled = true;
    if (isNewPattern) {
      btn.classList.remove('is-success');
      btn.classList.add('is-loading');
    } else {
      originalHTML = btn.innerHTML;
      btn.innerHTML = '<span style="opacity:0.7">Dodaję...</span>';
    }

    var body = {
      id: parseInt(d.variantId, 10),
      quantity: parseInt(d.quantity, 10) || 1
    };
    if (d.sellingPlanId) {
      var planId = parseInt(d.sellingPlanId, 10);
      if (!isNaN(planId)) body.selling_plan = planId;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Cart error ' + res.status);
      return res.json();
    })
    .then(function() {
      if (isNewPattern) {
        /* Wait for pour-fill to complete (~320ms) then swap to success state */
        setTimeout(function() {
          btn.classList.remove('is-loading');
          btn.classList.add('is-success');
        }, prefersReducedMotion ? 0 : 320);
        /* Total visible duration: 320ms fill + 200ms swap + 360ms check draw + ~720ms hold */
        setTimeout(function() {
          btn.classList.remove('is-success');
          btn.disabled = false;
        }, prefersReducedMotion ? 1000 : 1800);
      } else {
        btn.innerHTML = '<span style="color:#0A1A0E">Dodano ✓</span>';
        setTimeout(function() {
          btn.innerHTML = originalHTML;
          btn.disabled = false;
        }, 1500);
      }

      if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.onItemAdded === 'function') {
        window.Shopify.onItemAdded();
      }
      document.dispatchEvent(new CustomEvent('cart:item-added'));

      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var countEls = document.querySelectorAll('[data-cart-count], .cart-count-bubble span');
          countEls.forEach(function(el) { el.textContent = cart.item_count; });
        });
    })
    .catch(function(err) {
      console.error('ATC Error:', err);
      if (isNewPattern) {
        btn.classList.remove('is-loading', 'is-success');
      } else {
        btn.innerHTML = originalHTML;
      }
      btn.disabled = false;
      if (productForm) productForm.submit();
    });
  }

  if (heroAtcBtn) {
    heroAtcBtn.addEventListener('click', function(e) {
      e.preventDefault();
      addToCart(heroAtcBtn);
    });
  }

  if (stickyAtcBtn) {
    stickyAtcBtn.addEventListener('click', function(e) {
      e.preventDefault();
      addToCart(stickyAtcBtn);
    });
  }

  /* ══════════════════════════════════════════
     ONE-TIME PURCHASE LINK — AJAX add + redirect to /cart
     (IM8 pattern: POST to /cart/add.js then navigate)
     Uses document-level capture-phase delegation so theme-global
     handlers (cart.js, cart-drawer.js) can't steal the click.
  ══════════════════════════════════════════ */
  document.addEventListener('click', function(e) {
    var link = e.target && e.target.closest ? e.target.closest('.bb-onetime__link') : null;
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();
    if (link.dataset.busy === '1') return;
    link.dataset.busy = '1';

    var id = parseInt(link.dataset.variantId, 10);
    var fallback = link.dataset.fallbackHref || '/cart';
    if (!id) { link.dataset.busy = ''; return; }

    /* Request sections for the cart-drawer so the theme's <cart-drawer>
       renderContents() can repaint + open the widget. */
    var cartDrawer = document.querySelector('cart-drawer');
    var body = { id: id, quantity: 1 };
    var onetimePlanId = parseInt(link.dataset.sellingPlanId, 10);
    if (!isNaN(onetimePlanId)) body.selling_plan = onetimePlanId;
    if (cartDrawer) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function(res) {
      if (!res.ok) return res.json().then(function(err) { throw new Error(err.description || 'Cart error'); });
      return res.json();
    })
    .then(function(parsedState) {
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsedState); /* repaints + calls .open() */
      }
      /* Update header cart count bubbles as a belt-and-braces measure */
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.querySelectorAll('[data-cart-count], .cart-count-bubble span')
            .forEach(function(el) { el.textContent = cart.item_count; });
        });
      /* Also fire custom event in case other listeners (Triplewhale etc.) care */
      document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { variantId: id, quantity: 1 } }));
      link.dataset.busy = '';
    })
    .catch(function(err) {
      console.error('[onetime ATC]', err);
      link.dataset.busy = '';
      /* Stay on the page — the store uses a cart widget, not /cart navigation.
         Surface a brief error hint near the link. */
      var existingMsg = link.parentElement.querySelector('.bb-onetime__error');
      if (!existingMsg) {
        var msg = document.createElement('span');
        msg.className = 'bb-onetime__error';
        msg.textContent = 'Nie udało się dodać do koszyka. Spróbuj ponownie.';
        link.parentElement.appendChild(msg);
        setTimeout(function() { if (msg.parentElement) msg.parentElement.removeChild(msg); }, 4000);
      }
    });
  }, true); /* capture phase — beats bubbling theme handlers */

  /* ══════════════════════════════════════════
     STICKY BAR VISIBILITY
  ══════════════════════════════════════════ */
  if (stickyBar && productSection && 'IntersectionObserver' in window) {
    new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        stickyBar.classList.toggle('is-visible', !e.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '-100px 0px 0px 0px' }).observe(productSection);
  }

  /* ══════════════════════════════════════════
     GALLERY — CSS scroll-snap + thumb/dot sync
     Mobile: native scroll-snap horizontal swipe
     Desktop: opacity-fade via is-active class
  ══════════════════════════════════════════ */
  var galleryMain = document.getElementById('gallery-main');
  var galleryThumbs = document.getElementById('gallery-thumbs');
  var galleryDots = document.getElementById('gallery-dots');
  var totalSlides = galleryMain ? galleryMain.querySelectorAll('.gallery__main-slide').length : 0;
  var currentSlide = 0;

  function updateActiveState(idx) {
    if (idx < 0 || idx >= totalSlides) return;
    currentSlide = idx;

    /* Update slides (used for desktop opacity-fade via is-active CSS) */
    if (galleryMain) {
      galleryMain.querySelectorAll('.gallery__main-slide').forEach(function(slide) {
        slide.classList.toggle('is-active', parseInt(slide.dataset.idx) === idx);
      });
    }

    /* Update thumbs */
    if (galleryThumbs) {
      galleryThumbs.querySelectorAll('.gallery__thumb').forEach(function(t) {
        t.classList.toggle('is-active', parseInt(t.dataset.idx) === idx);
      });
      var activeThumb = galleryThumbs.querySelector('.gallery__thumb.is-active');
      if (activeThumb) {
        activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    }

    /* Update dots */
    if (galleryDots) {
      galleryDots.querySelectorAll('.gallery__dot').forEach(function(d) {
        d.classList.toggle('is-active', parseInt(d.dataset.idx) === idx);
      });
    }
  }

  /* Navigate to slide: scroll on mobile (CSS handles snap), toggle is-active on desktop */
  function goToSlide(idx) {
    if (!galleryMain || idx < 0 || idx >= totalSlides) return;
    galleryMain.scrollTo({ left: idx * galleryMain.offsetWidth, behavior: 'smooth' });
    updateActiveState(idx);
  }

  /* Sync active state from scroll position (fires on mobile, noop on desktop where overflow:hidden) */
  if (galleryMain) {
    var scrollTimer = null;
    galleryMain.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        var w = galleryMain.offsetWidth;
        if (!w) return;
        var idx = Math.round(galleryMain.scrollLeft / w);
        if (idx !== currentSlide) updateActiveState(idx);
      }, 80);
    }, { passive: true });
  }

  /* Thumb clicks */
  if (galleryThumbs) {
    galleryThumbs.querySelectorAll('.gallery__thumb').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        goToSlide(parseInt(this.dataset.idx));
      });
    });
  }

  /* Dot clicks */
  if (galleryDots) {
    galleryDots.querySelectorAll('.gallery__dot').forEach(function(dot) {
      dot.addEventListener('click', function() {
        goToSlide(parseInt(this.dataset.idx));
      });
    });
  }

  /* ══════════════════════════════════════════
     FAQ ACCORDION
  ══════════════════════════════════════════ */
  document.querySelectorAll('.faq-item').forEach(function(item) {
    var btn = item.querySelector('.faq-q');
    if (!btn) return;
    btn.addEventListener('click', function() {
      var isOpen = item.classList.contains('is-open');
      item.parentElement.querySelectorAll('.faq-item').forEach(function(s) {
        if (s !== item) s.classList.remove('is-open');
      });
      item.classList.toggle('is-open', !isOpen);
    });
  });

  /* ══════════════════════════════════════════
     CSS .reveal CLASS OBSERVER
  ══════════════════════════════════════════ */
  if ('IntersectionObserver' in window) {
    var cssRevealObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          cssRevealObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.reveal').forEach(function(el) {
      cssRevealObs.observe(el);
    });
  }

  /* ════════════════════════════════════════════
     EVIDENCE — staggered card reveal
  ════════════════════════════════════════════ */
  if ('IntersectionObserver' in window) {
    var evidenceSection = document.getElementById('evidence');
    if (evidenceSection) {
      var statCards = evidenceSection.querySelectorAll('.stat');

      if (!prefersReducedMotion) {
        statCards.forEach(function(card) {
          card.style.opacity = '0';
          card.style.transform = 'translateY(32px)';
          card.style.transition = 'opacity 0.7s cubic-bezier(0.16,1,0.3,1), transform 0.7s cubic-bezier(0.16,1,0.3,1)';
        });
      }

      var evidenceGrid = evidenceSection.querySelector('.evidence__grid') || evidenceSection;

      var evidenceObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (!e.isIntersecting) return;
          if (!prefersReducedMotion) {
            statCards.forEach(function(card, i) {
              setTimeout(function() {
                card.style.opacity = '1';
                card.style.transform = 'translateY(0)';
              }, i * 180);
            });
          }
          evidenceObs.unobserve(e.target);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });

      evidenceObs.observe(evidenceGrid);
    }
  }

  /* ══════════════════════════════════════════
     SECTION REVEALS — Directional
     Light sections: opacity + subtle translateY(16px → 0)
     Dark sections: opacity only (no translate — shadows would jitter)
     Evidence is handled separately above (staggered cards + count-up).
     Entirely skipped under prefers-reduced-motion: no initial offset,
     no observer, sections render at rest.
  ══════════════════════════════════════════ */
  if ('IntersectionObserver' in window && !prefersReducedMotion) {
    var revealTargets = [];
    document.querySelectorAll('section[id]').forEach(function(s) {
      if (s.id === 'product') return;
      if (s.id.indexOf('shopify-section') === 0) return;
      if (s.id === 'evidence') return; // handled by its own observer
      var isLight = !!s.closest('.section-light') || s.classList.contains('section-light');
      s.setAttribute('data-reveal', isLight ? 'light' : 'dark');
      if (isLight) {
        s.style.opacity = '0';
        s.style.transform = 'translateY(16px)';
        s.style.transition = 'opacity 600ms cubic-bezier(0.16,1,0.3,1), transform 700ms cubic-bezier(0.16,1,0.3,1)';
      } else {
        s.style.opacity = '0';
        s.style.transition = 'opacity 700ms cubic-bezier(0.16,1,0.3,1)';
      }
      revealTargets.push(s);
    });

    var revealObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (!e.isIntersecting) return;
        e.target.style.opacity = '1';
        if (e.target.getAttribute('data-reveal') === 'light') {
          e.target.style.transform = 'translateY(0)';
        }
        e.target.addEventListener('transitionend', function handler(ev) {
          if (ev.propertyName === 'transform') {
            ev.target.style.transform = '';
            ev.target.removeEventListener('transitionend', handler);
          }
        });
        revealObs.unobserve(e.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    revealTargets.forEach(function(s) { revealObs.observe(s); });
  }

})();
